export const state = {
  isToggle: true,
};

export const getters = {
  getToggle(state) {
    return state.isToggle;
  },
};
export const mutations = {
  setIsToggleMut(state, payload) {
    state.isToggle = payload;
  },
};

export const actions = {
  setToggleAction({ commit }, { isToggle }) {
    commit("setIsToggleMut", isToggle);
  },
};
